import { TranslationMap } from '@trimble-gcs/i18n-types';

export function scan3dClassificationTranslations() {
  return {
    noData: {
      text: $localize`:@@scan3dClassification.noData:No classification data.`,
      desc: 'Text displayed when no classification data is available.',
    },
    unallocated: {
      '=1': {
        text: $localize`:@@scan3dClassification.unallocated.one:{count} other class with zero value not shown`,
        desc: 'Text displayed for one unallocated classification',
      },
      other: {
        text: $localize`:@@scan3dClassification.unallocated.other:{count} other classes with zero value not shown`,
        desc: 'Text displayed for multiple unallocated classifications.',
      },
    },
    blendIntensity: {
      text: $localize`:@@scan3dClassification.blendIntensity:Blend Intensity`,
      desc: 'Label for the switch to show the point cloud with classification and blended intensity coloring.',
      limit: 30,
    },
  } satisfies TranslationMap;
}
